// extracted by mini-css-extract-plugin
export default {"header":"Header_header__mtodi","main-image":"Header_main-image__SsLf9"};